/** Public build-time config (Vite env). */
const env = (import.meta as unknown as { env?: Record<string, string | undefined> }).env ?? {};
export const API_BASE = (env.VITE_API_BASE ?? '').replace(/\/$/, '');
export const SUPABASE_URL = (env.VITE_SUPABASE_URL ?? '').replace(/\/$/, '');
export const WORKSPACE_DOMAIN = env.VITE_GOOGLE_WORKSPACE_DOMAIN ?? '';
/** Local development against `wrangler dev` with ENVIRONMENT=development and STORE=memory. */
export const DEV_LOGIN = env.VITE_DEV_LOGIN === 'true';
